export default {
	main: '#5028CC',
	secondary: '#FE6600',
	gradientModal: 'linear-gradient(to bottom,#8965FF, #5930E3)',
	gradientCard: 'linear-gradient(226deg,#9b76f3, rgb(51,61,152))'
}
